import { TagAction } from "../../../types/Tag.types";
import { useUrls } from "../../../app/Providers/AppContext";
import { Claims } from "../../../svg";
import styles from "./PolicyTiles.module.scss";
import { useState } from "react";
import { getFileClaimUrl } from "../../../utils/urlUtils";
import { CallToAction, PopoverTile } from "../../PopoverTile";
import { PolicyDetails } from "shared";

type ClaimsTileProps = {
  policy: PolicyDetails;
};

const fileClaimTagAction: TagAction = {
  actionName: "File a claim",
  actionType: "link",
};
const claimStatusTagAction: TagAction = {
  actionName: "Claim status",
  actionType: "link",
};

export const ClaimsTile = ({ policy }: ClaimsTileProps) => {
  const [redirect, setRedirect] = useState(false);
  const [isPopOverOpen, setIsPopOverOpen] = useState(false);

  const { country, policyNumber } = policy;
  const urls = useUrls();

  const onClickLink = () => {
    setRedirect(true);
  };

  const ctaList: CallToAction[] = [
    {
      tagAction: fileClaimTagAction,
      onClick: onClickLink,
      href: getFileClaimUrl(policy, urls),
      label: "File a claim",
    },
  ];
  if (country === "USA") {
    ctaList.push({
      tagAction: claimStatusTagAction,
      onClick: onClickLink,
      href: urls.insurance.fileClaim(policyNumber, country),
      label: "Claim status",
    });
  }

  return (
    <PopoverTile
      icon={<img src={Claims} alt="Claims" aria-hidden="true" />}
      className={styles.tile}
      cta="Claims"
      onClick={() => setIsPopOverOpen(!isPopOverOpen)}
      isLoading={redirect}
      ctaList={ctaList}
    />
  );
};
